var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    directives: [
      { name: "show", rawName: "v-show", value: false, expression: "false" },
    ],
    staticClass: "sug_wraper",
    attrs: { id: "sug_wraper" },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }